import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-token-login',
  templateUrl: './token-login.component.html',
  styleUrls: ['./token-login.component.scss']
})
export class TokenLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
